import React from 'react';
import Stack from 'react-bootstrap/Stack';
import Form from 'react-bootstrap/Form';
import { useCallback, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { FormLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import parseJSON from '../../helpers/parse-json';
import prettify from '../../helpers/prettify';
import ordered from '../../helpers/ordered';

const textArea = { width: '700px', margin: '20px', fontFamily: 'Courier New' }
const link = { width: '200px', height: '50px', margin: '10px', padding: '5px', color: 'red', backgroundColor: 'lightgray', textAlign: 'center' }

function JSONComparison() {
  const [alertMsg, setAlertMsg] = useState('');
  const [jsonOrText1, setJsonOrText1] = useState();
  const [jsonOrText2, setJsonOrText2] = useState();
  const [isJSON, setIsJSON] = useState();
  const [alertVariant, setAlertVariant] = useState('info');

  const checkParsedJSON = useCallback((parsed) => {
    if (!parsed) {
      setAlertMsg('JSON is not parsed!');
      setAlertVariant('danger');
      return false;
    }
    else if (Object.keys(parsed).length === 0) {
      setAlertMsg('JSON is empty!');
      setAlertVariant('info');
    }
    else {
      setAlertMsg();
    }

    return true;
  }, [setAlertMsg, setAlertVariant]);

  const handleJson1Change = useCallback((e) => {
    if (!e.target.value) {
      return;
    }

    const parsed = parseJSON(e.target.value);

    if (checkParsedJSON(parsed)) {
      setJsonOrText1(parsed);
      prettify('json1');
      setIsJSON(true);
    }
    else {
      setJsonOrText1(e.target.value);
      setIsJSON(false);
    }

  }, [parseJSON, setJsonOrText1, setIsJSON]);

  const handleJson2Change = useCallback((e) => {
    if (!e.target.value) {
      return;
    }

    const parsed = parseJSON(e.target.value);

    if (checkParsedJSON(parsed)) {
      setJsonOrText2(parsed);
      prettify('json2');
      setIsJSON(true);
    }
    else {
      setJsonOrText2(e.target.value);
      setIsJSON(false);
    }

  }, []);

  const handleCompare = useCallback(() => {
    if (isJSON) {

      if (JSON.stringify(ordered(jsonOrText1)) === JSON.stringify(ordered(jsonOrText2))) {
        setAlertMsg('Same!');
        setAlertVariant('success');
      }
      else {
        setAlertMsg('Different!');
        setAlertVariant('warning');
      }
    }
    else {
      if (jsonOrText1 === jsonOrText2) {
        setAlertMsg('Same!');
      }
      else {
        setAlertMsg('Different!')
      }
    }
  }, [isJSON, jsonOrText1, jsonOrText2]);

  return (
    <Stack>
      <FloatingLabel as='header' className="ValidateSchema-header">
        JSON / Text comparison
        <Stack direction='horizontal' style={{ alignItems: 'center' }}>
          <Link style={link} to='/'>Main page</Link>
        </Stack>
      </FloatingLabel>

      <Stack direction='vertical' className="App" style={{ margin: '40px' }}>

        <Stack direction='horizontal' gap={3} className="mx-auto"  >
          <Form.Control id="json1" placeholder='JSON or Text 1' style={textArea} onBlur={handleJson1Change} as="textarea" rows={20} />
          <Form.Control id="json2" placeholder='JSON or Text 2' style={textArea} onBlur={handleJson2Change} as="textarea" rows={20} />
        </Stack>

        <Stack direction='horizontal' className="mx-auto">
          <Button onClick={handleCompare} style={{ width: '100px' }}>Compare</Button>
        </Stack>

        <Stack direction='vertical'>
          {
            alertMsg &&
            <>
              <FormLabel>Result: </FormLabel>
              <Alert variant={alertVariant} dismissible>{alertMsg}</Alert>
            </>
          }
        </Stack>
      </Stack>
    </Stack>
  )
}

export default JSONComparison;